<template>
  <a-modal
    v-model="visible"
    width="840px"
    wrap-class-name="apply-join-modal"
    title="供应商入驻指引"
    @cancel="visible = false"
  >
    <a-tabs v-model="activeKey" type="card">
      <a-tab-pane key="1" tab="入驻流程">
        <a-steps :current="-1" labelPlacement="vertical">
            <a-step title="用户注册、登录" />
            <a-step title="创建企业" />
            <a-step title="提交认证" />
            <a-step title="认证审核" />
        </a-steps>
        <div class="desc">
            <span>1. 用户注册、登录</span>
            <p>首先，您需要在我们的平台上注册一个账号并完成登录。</p>
        </div>
        <div class="desc">
            <span>2. 创建企业</span>
            <p>登录后，在控制台点击"创建企业"按钮，填写企业基本信息，包括企业名称、所属行业、联系方式等。请确保信息的准确性和完整性。</p>
        </div>
        <div class="desc">
            <span>3. 提交企业认证资料</span>
            <p>完成企业创建后，您需要提交相关资质文件进行认证，包括营业执照、法人身份证明等。所有文件需清晰扫描或拍照上传。</p>
        </div>
        <div class="desc">
            <span>4. 认证审核</span>
            <p>平台会对提交的申请进行审核，审核内容包括资质文件的真实性、完整性，以及是否符合平台的入驻要求等。审核时间一般为 1-3 个工作日。</p>
        </div>
      </a-tab-pane>
      <a-tab-pane key="2" tab="入驻条件">
        <div class="condition">
            <span>成为我们平台的软件供应商，需要满足以下条件：</span>
            <div>
                <p>1、具备独立法人资格的企业或组织，能够独立承担民事责任</p>
                <p>2、拥有合法有效的营业执照及相关行业经营资质</p>
                <p>3、具有良好的商业信誉，无重大违法违规记录</p>
                <p>4、软件产品需拥有自主知识产权（如软件著作权登记证书），无侵权纠纷；若涉及第三方授权，需提供完整授权文件。</p>
            </div>
        </div>
      </a-tab-pane>
    </a-tabs>
    <template #footer>
      <!-- <a-button @click="visible = false">取 消</a-button> -->
      <a-button @click="handleSubmit" class="btn-red">申请入驻</a-button>
    </template>
  </a-modal>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      visible: false,
      activeKey: "1",
    };
  },
  methods: {
    ...mapActions(["GetInfo"]),
    open() {
      this.visible = true;
    },
    handleSubmit() {
      window.open(`${process.env.VUE_APP_ACCOUNT_PREFIX}/userLayout/userInfo/addCompany`);
      this.visible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.desc{
    padding: 12px;
    border-radius: 4px;
    border: 1px solid #e8e8e8;
    margin-top: 16px;
    >span{
        display: block;
        color: #232323;
        margin-bottom: 8px;
    }
}
.condition{
    >span{
        display: block;
        color: #232323;
        margin-bottom: 8px;
    }
    >div{
        line-height: 22px;
    }
}
</style>
